import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './Remark.scss';
function Remark(props) {
    const showScore = () => {
        if (!props.score)
            return false;
        if (props.displayScore === 'yes') {
            return true;
        }
        else if (props.displayScore === 'no') {
            return false;
        }
        else if (props.displayScore === "auto") {
            return Number(props.score) >= 4;
        }
        return false;
    };
    const removeQuotes = (str) => {
        if (str.charAt(0) === '"' && str.charAt(str.length - 1) === '"') {
            return str.slice(1, -1);
        }
        return str;
    };
    return <View x-if={showScore() || props.soldInfo} className="comprehensive-card-remark-container">
      {showScore() && <View className="comprehensive-card-remark-score-container">
          <Text className="comprehensive-card-remark-score">{props.score}</Text>
        </View>}
      {props.recommendReason ? <View className="comprehensive-card-remark-avgScoreDesc">
          <Text className="comprehensive-card-remark-avgScoreDesc-text" numberOfLines={1}>
            {`"${removeQuotes(props.recommendReason)}"`}
          </Text>
        </View> : null}
      {props.soldInfo && <Text className="comprehensive-card-remark-number">已售{props.soldInfo}</Text>}
    </View>;
}
export default memo(Remark);
